import { ChartData, ChartOptions } from 'chart.js';
import React from 'react';
import { Bar } from 'react-chartjs-2';
import { FormatToShortPriceTemplate } from '../../../../../utils/FormatValue';

const PRODUCT_NAME = 'product';
const PRODUCT_COLOR = '#F3A1B8';

interface IProductMaterialBarData {
  name: string;
  color: string;
  pricePerUnit: number;
}

interface Props {
  materialsData: IProductMaterialBarData[];
  productPricePerUnit?: number;
}

const ProductChart: React.FC<Props> = ({ materialsData, productPricePerUnit }) => {
  const materialsDataWithProduct = [
    ...materialsData,
    { name: PRODUCT_NAME, color: PRODUCT_COLOR, pricePerUnit: productPricePerUnit || 0 },
  ];

  const data: ChartData<'bar'> = {
    labels: materialsDataWithProduct.map((item) => item.name),
    datasets: [
      {
        label: 'Price per Unit',
        data: materialsDataWithProduct.map((item) => item.pricePerUnit),
        backgroundColor: materialsDataWithProduct.map((item) =>
          item.name === PRODUCT_NAME ? 'rgba(0, 0, 0, 0)' : item.color,
        ),
        borderColor: materialsDataWithProduct.map((item) => item.color),
        borderWidth: 2,
        barThickness: 30,
      },
    ],
  };

  const options: ChartOptions<'bar'> = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false, // Disable the legend
      },
    },

    scales: {
      y: {
        min: 0,
        beginAtZero: true,
        grace: '20%',
        ticks: {
          callback: function (value) {
            return FormatToShortPriceTemplate(value as number);
          },
        },
      },
      x: {
        grid: {
          display: false,
        },
      },
    },
  };

  return <Bar data={data} options={options} />;
};

export default ProductChart;
